//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from "store/constants";

//  ----------------------------------------------------------------------------
//  Actions
//  ----------------------------------------------------------------------------

//  -- Create log ----------------
export const setLoadQuizAndClassActivity = (returnPayload) => ({
    type: ActionTypes.loaderQuizAndActivity.setLoaderQuizAndActivity,
    payload: returnPayload,
  });
  